// @ts-check

if (!customElements.get("ff-input-block-submit")) {
  class FfInputBlockSubmit extends HTMLElement {
    constructor() {
      super();

      /**
       * @type {HTMLInputElement}
       */
      this.ffInput = (() => {
        /**
         * @type {HTMLInputElement | null}
         */
        const input = this.querySelector("[data-ff-input-block-submit]");

        if (input) {
          return input;
        } else {
          throw new Error("Missing input");
        }
      })();


      const {
        errorSelector,
        showErrorClass,
        submitSelector
      } = this.ffInput.dataset;

      /**
       * @type {HTMLButtonElement}
       */
      this.ffSubmitEl = (() => {
        /**
         * @type {HTMLButtonElement | null}
         */
        const submitEl = document.querySelector(submitSelector || "");

        if (submitEl) {
          return submitEl;
        } else {
          throw new Error("Missing submit element");
        }
      })();

      /**
       * @type {HTMLElement}
       */
      this.ffErrorEl = (() => {
        /**
         * @type {HTMLElement | null}
         */
        const errorEl = this.querySelector(errorSelector || "");

        if (errorEl) {
          return errorEl;
        } else {
          throw new Error("Missing error element");
        }
      })();

      /**
       * @type {String}
       */
      this.ffShowErrorClass = (() => {
        if (showErrorClass) return showErrorClass
        else throw new Error("Missing show error class.")
      })()

      this.init();
    }

    init() {
      this.ffInput.addEventListener("input", this.inputHandler);
      this.inputHandler();
    }

    inputHandler = () => {
      const { checked, dataset, value } = this.ffInput;
      const {
        errorWidthMatch,
        errorEmptyMsg,
        errorFormatMsg,
        errorUncheckedMsg,
        validFormat,
      } = dataset;

      let errorMsg = "";
      
      this.ffSubmitEl.removeEventListener("click", this.submitHandlerBlock);
      this.ffErrorEl.classList.remove(this.ffShowErrorClass);
      if (errorWidthMatch) {
        this.ffErrorEl.style.width = `${this.ffInput.clientWidth}px`;
      }

      if (errorUncheckedMsg) {
        if (!checked) {
          errorMsg = errorUncheckedMsg;
        }
      }

      if (errorFormatMsg && validFormat) {
        const validation = new RegExp(validFormat);
        if (!validation.test(value)) {
          errorMsg = errorFormatMsg;
        }
      }

      if (errorEmptyMsg) {
        if (value.length == 0) {
          errorMsg = errorEmptyMsg;
        }
      }

      /**
        * @type {string[]} The submit button can be blocked by many inputs, so they use dataset to know whose are blocking the submit
        */
      let blockedBy = JSON.parse(this.ffSubmitEl.dataset.blockedBy || "[]");
      if (errorMsg) {
        this.ffErrorEl.innerHTML = errorMsg;
        blockedBy.push(this.ffInput.name);
        this.ffSubmitEl.dataset.blockedBy = JSON.stringify(blockedBy);
        this.ffSubmitEl.addEventListener("click", this.submitHandlerBlock);
      } else {
        blockedBy = blockedBy.filter((name) => name != this.ffInput.name);
        this.ffSubmitEl.dataset.blockedBy = JSON.stringify(blockedBy);
      }
    };

    submitHandlerBlock = (e) => {
      this.ffErrorEl.classList.add(this.ffShowErrorClass);
      e.preventDefault();
    };
  }

  customElements.define("ff-input-block-submit", FfInputBlockSubmit);
}
